import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import { ActionType, mauiDiagramPastePluginKey } from '../pm-plugins/maui-diagram-paste-plugin';

export const dismissDiagramPasteFlag =
	(): EditorCommand =>
	({ tr }) => {
		tr.setMeta(mauiDiagramPastePluginKey, {
			type: ActionType.DISMISS_FLAG,
		});
		return tr;
	};
